export default __webpack_public_path__ + "static/media/trash.ded74163.svg";